export class Certificate {
  constructor(public id?: string, public name?: string) {}
}
